import moment from "moment";



export  function getTimeDifference(date) {
    const now = moment();
    const dddd = moment(date);
    const diff = moment.duration(dddd.diff(now));
    console.log(date);
   
    if (diff.asMinutes() < 60) {
      const minutes = Math.round(diff.asMinutes());
      return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
    } else {
      const hours = Math.round(diff.asHours());
      return `${hours} hour${hours !== 1 ? 's' : ''}`;
    }
}



export function formatAlertTitle (text) {
   if (!text) return "";
    return text
        .toLowerCase()                          // Force everything to lowercase first
        .split('_')                             // Split at the underscore
        .map(word => 
            word.charAt(0).toUpperCase() + word.slice(1) // Capitalize only the first letter
        )
        .join(' ');                      // Join back with spaces
};